import { bridge } from '@sloyd/viewer';
import { useEffect, useState } from 'react';
import { useCounter } from 'react-use';
import { addListener } from 'shared-base';
import { generateModel, randomizeAll } from './extra.utils';

export function useModel(id: string, isLoaded: boolean) {
  const [count, { inc, reset }] = useCounter(0);
  const [activeCount, setActiveCount] = useState();
  const [isReady, setIsReady] = useState(false);

  function random(focus: boolean) {
    setIsReady(false);
    reset();
    randomizeAll();

    if (focus) {
      setTimeout(() => {
        bridge.cameraFocus('main');
      }, 200);
    }
  }

  useEffect(() => {
    if (count === activeCount) {
      setIsReady(true);
      reset();
    }
  }, [count, activeCount]);

  useEffect(() => {
    if (!isLoaded) return;
    generateModel('main', id ?? '').then((model: any) => {
      if (!model) return;
      const { active } = model;

      setActiveCount(active.length);

      bridge.replaceModel('main', model);
    });
  }, [id, isLoaded]);

  useEffect(() => {
    function onTextLoaded() {
      inc();
    }

    const unlisten = addListener('UNITY/texture/loaded', onTextLoaded);

    return () => {
      unlisten();
    };
  }, []);

  return [isReady, { random }] as const;
}
